module.exports = __webpack_public_path__ + "img/product1-1.dbf07389.png";